import { render, staticRenderFns } from "./UserRoleLabel.vue?vue&type=template&id=052ab3c6&scoped=true&lang=true"
import script from "./UserRoleLabel.vue?vue&type=script&lang=js"
export * from "./UserRoleLabel.vue?vue&type=script&lang=js"
import style0 from "./UserRoleLabel.vue?vue&type=style&index=0&id=052ab3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ab3c6",
  null
  
)

export default component.exports